import { Data } from './data';
import { Flux } from './flux';
import { Partenaire } from './partenaire';

export class CashSession extends Data {

    nom: string;
    nature: string;
    description: string;
    archiver: boolean;
    solde_initial: number;
    // solde_final: number;
    cache_solde_final: number;
    date_cloture: string;
    flux: Flux[];
    partenaire: Partenaire;



    // recent_token: Token;
    constructor() {

        super(); // on appelle le constructeur du parent;
        this.solde_initial = 0;

    }


    get labelNom(): string {
        if (this.partenaire !== null && this.partenaire !== undefined)
        return  this.partenaire.nom;
        else
        return this.nom;
    }

    get labelNomSelect(): string {
        return this.labelNom + ' - ' + this.labelNature;
    }


    get labelNature(): string {

        let label = '';

        if (this.nature === 'espece')
        label = 'Espèce';

        if (this.nature === 'banque')
        label = 'Banque';

        if (this.nature === 'depot')
        label = 'Dépôt';

        if (this.nature === 'credit')
        label = 'Emprunt/Prêt';

        return  label;

    }


    get lastSession(): string {
        if (this.date_cloture !== null && this.date_cloture !== undefined)
        return  this.formatDate(this.date_cloture);
        else
        return this.formatDate(this.date_create);
    }

    // utilisé pour le tri car le format anglais respecte l'ordre
    get englishFormatlastSession(): string {
        if (this.date_cloture !== null && this.date_cloture !== undefined)
        return  this.englishFormatDate(this.date_cloture);
        else
        return this.englishFormatDate(this.date_create);
    }

    get entrees(): number {

        let totalentrees = 0;

        if (this.flux !== null && this.flux !== undefined) {

            for ( let i = 0; i < this.flux.length; i++) {

                if (this.flux[i].type_flux === 'entree')
                totalentrees += this.flux[i].montant;
            }
        }

        return totalentrees;
    }

    get sorties(): number {


        let totalsorties = 0;

        if (this.flux !== null && this.flux !== undefined) {

            for ( let i = 0; i < this.flux.length; i++) {

                if (this.flux[i].type_flux === 'sortie')
                totalsorties += this.flux[i].montant;
            }

        }

        return totalsorties;
    }

    get soldeFinal(): number {

        return this.solde_initial +  this.entrees - this.sorties;
    }

    get etat(): string {

        if (this.date_cloture === undefined || this.date_cloture === null)
        return 'Ouvert';
        else
        return 'Fermé';
    }

    get user(): string {

        if (this.create_by !== null && this.create_by !== undefined) {
            return this.create_by.username;
        } else {
            return null;
        }

    }

    get formatDateOpen(): string {

        return  this.formatDate(this.date_create);

    }

    get formatDateClose(): string {

        return  this.formatDate(this.date_cloture);

    }


}
